import axios from "axios";
import Student from "@/models/student";
import { applyErrorHandlers } from '@/decorators/applyErrorHandler';

const API_STUDENT_URL = process.env.VUE_APP_API_URL+"/students";

export default class StudentController {
  // Fetch student by UCO
  static async fetchStudentByUCO(uco) {
      const response = await axios.get(`${API_STUDENT_URL}/get_student_by_uco/${uco}`);
      return new Student(response.data);
  }

  // Transder student results
  static async transferResultsForStudents(list_of_students_ucos) {
      console.log("List of ucos:", list_of_students_ucos);
      const response = await axios.post(`${API_STUDENT_URL}/transmit_results_for_selected_students`, list_of_students_ucos);
      console.log("Results transfer - send successfully:", response.data);
      return response.data;
  }

  // Transder all students results
  static async transferResultsForAllStudents() {
      const response = await axios.post(`${API_STUDENT_URL}/transmit_results_for_all_students`);
      console.log("Results transfer - send successfully:", response.data);
      return response.data;
  }
    
  // Generate and download csv of results
  static async generateAndDownloadCSV(list_of_students_ucos = []) {
    console.log("List of ucos:", list_of_students_ucos);
    const response = await axios.post(`${API_STUDENT_URL}/generate_results_csv`, list_of_students_ucos, {
      responseType: 'blob'
    });
    return response;
  }

  // Download list of non-archived student UCOs
  static async downloadStudentsUcos() {
    const API_FILE_URL = process.env.VUE_APP_API_URL + "/files";
    const response = await axios.get(`${API_FILE_URL}/download_students_ucos`, {
      responseType: 'blob'
    });
    return response;
  }
}

applyErrorHandlers(StudentController);
